import { render, staticRenderFns } from "./TabBoxesContainer.vue?vue&type=template&id=13190c39&scoped=true"
import script from "./TabBoxesContainer.vue?vue&type=script&lang=js"
export * from "./TabBoxesContainer.vue?vue&type=script&lang=js"
import style0 from "./TabBoxesContainer.vue?vue&type=style&index=0&id=13190c39&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13190c39",
  null
  
)

export default component.exports